<template>
  <main>
    <component :is="$route.meta.layout || 'div'">
      <v-main class="pt-4">
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-main>
    </component>
  </main>

</template>

<script>
// Import Pages
import Login from './components/Login.vue'
import Header from './components/Header.vue'
import SideMenu from './components/SideMenu.vue'
import Dashboard from './components/Dashboard.vue'
import Properties from './components/Properties.vue'
import Vehicles from './components/Vehicles.vue'
import Salaries from './components/Salaries.vue'
import Expenses from './components/Expenses.vue'
import Cash from './components/Cash.vue'
import Loans from './components/Loans.vue'
import SuperFunds from './components/SuperFunds.vue'
import BrokerTxns from './components/BrokerAccounts.vue'
import BankAccountSummary from './components/BankAccountSummary.vue'
import BankAccountTxns from './components/BankAccountTxns.vue'
import Homepage from './components/Homepage.vue'
import PortfolioSegmentation from './components/PortfolioSegmentation.vue'

// Import Layouts (don't think I need to)
import BlankLayout from './layouts/BlankLayout.vue'
import AppLayout from './layouts/AppLayout.vue'


export default {
  name: 'App',
  components: {
    Login,
    Header,
    SideMenu,
    Dashboard,
    Properties,
    Vehicles,
    Expenses,
    Salaries,
    Cash,
    Loans,
    SuperFunds,
    BrokerTxns,
    BankAccountSummary,
    BankAccountTxns,
    Homepage,
    PortfolioSegmentation,
  },
  data() {
    return {
      
    }
  }
}
</script>

<style>
#app {
  font-family: "Space Grotesk", "Courier New", Courier, monospace, sans-serif;
  font-weight: 300;
  font-size: 1.15rem;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

/* Vuetify typography scale classes set font-family: Roboto explicitly — override so Space Grotesk applies everywhere */
.text-caption, .text-overline,
.text-body-1, .text-body-2,
.text-subtitle-1, .text-subtitle-2,
.text-h1, .text-h2, .text-h3, .text-h4, .text-h5, .text-h6 {
  font-family: inherit !important;
}
</style>
